import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { faCircleArrowDown, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "../../../InfoIcon";

import { Link, useNavigate } from "react-router-dom";
import useVariable from './../../../../hook/useVariable';
import Backdrop from './../../../Backdrop';
import Filter from "./mobilecomponent/Filter";
import useRole from "../../../../hook/useRole";
import { notificationActions } from "../../../../store/notification-slice";
import useFetch from "../../../../hook/useFetch";



export default function MobileComponent(props) {


    let filteredUsers = useSelector((state) => state.user.filteredUsers)

    const [mobileItems, setMobileItems] = useState([])
    let stateusers = useSelector(state => state.user.users)

    useEffect(() => {

        let items = []
        let users = filteredUsers ?? stateusers
        if (users && Object.keys(users).length > 0) {
            users.forEach((user) => {

                items.push(<MobileItem key={user.id} user={user} />)

            })
        }
        setMobileItems(items)

    }, [filteredUsers])




    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}




const MobileItem = (props) => {
    const { user } = props
    const { variableValue } = useVariable()

    let id = variableValue(user.id)
    let username = variableValue(user.username)
    let email = variableValue(user.email)
    let isAdmin = variableValue(user.is_admin)
    let createdOn = variableValue(user.created_on)
    let status = variableValue(user.status)
    status = status ? 'online' : 'offline'
    const {hasrole}=useRole('rsosuperuser')
    const [showContent, setShowContent] = useState(false)

    let navigate=useNavigate()
    let dispatch=useDispatch()
    let token=useSelector(state=>state.user.token)
const {del}=useFetch()

    return <Fragment>
        

            <Fragment>
                <div className="card shadow  bg-white rounded p-3" style={{ cursor: 'pointer' }} onClick={() => {
                    setShowContent(!showContent)
                }}  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }} >
                        <span>{id}</span>
                        <span>{username}</span>
                        <span>{email}</span>
                    </div>
                    <InfoIcon icon={faCircleArrowDown} size='xl' />

                </div>
                {showContent &&
                    <table className="table table-striped table-bordered" >
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <td>{id}</td>
                            </tr>
                            <tr>
                                <th>Username</th>
                                <td>
                                    {username}
                                </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>
                                    {email}
                                </td>
                            </tr>
                            <tr>
                                <th>IsAdmin</th>
                                <td>
                                {isAdmin?'true':'false'}
                                </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>
                                    {status}
                                </td>
                            </tr>
                           <tr>
                            <th>
                                Activated
                            </th>
                            <td>
                                {user.activated?'true':'false'}
                            </td>
                           </tr>
                            <tr>
                                <th>CreatedOn</th>
                                <td>
                                    {createdOn}
                                </td>
                            </tr>
                            <tr>
                                <th>Edit</th>
                                <td>
                                    <Link className="btn btn-outline-secondary bgnt" to={`/admin/users/${id}`} ><InfoIcon icon={faEdit} title='edit user' /></Link>
                                </td>

                            </tr>
                            <tr>
                                <th>Delete</th>
                                <td>
                                     <button className="btn btn-warning" disabled={!hasrole} onClick={()=>{
                                                                  if (window.confirm('are you sure to delete user? The processes are saved in log!!!')) {
                                                                           del(`/admin/user?token=${token}`, {
                                                                               'id': id
                                                                           }, (data) => {
                                                                               dispatch(notificationActions.setNotification({
                                                                                   message: data,
                                                                                   status: false
                                                                               }))
                                                                           },
                                                                               () => {
                                                                                   dispatch(notificationActions.setNotification({
                                                                                       message: `user deleted`,
                                                                                       status: true
                                                                                   }))
                                                   
                                                   
                                                                                   navigate('/admin/users', {
                                                                                       state: {
                                                                                           refetch: true
                                                                                       }
                                                                                   })
                                                                               })
                                                                       }
                                                }} style={{width:'100%'}} ><InfoIcon   icon={faTrash} title='delete user' /></button>
                                </td>
                            </tr>
                       


                        </tbody>
                    </table>
                }

               

            </Fragment>

        
    </Fragment>


}